module.exports = __webpack_public_path__ + "static/media/skip.d26dbc9a.png";